import ApplicationView from './ApplicationView';
export default ApplicationView;
